import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniahireforlocaltripinpune() {



    const cardData =
    {
        keyword: 'Urbania Hire for Local Trip in Pune',
        heading: 'Urbania on rent in pune: Urbania Hire for Local Trip in Pune',
        headingDescription: 'Urbania On Rent in Pune offers dependable and comfortable Urbania Hire for Local Trip in Pune for families, corporate teams, tourists, and group travelers exploring the city. Our well-maintained Force Urbania fleet provides spacious seating, air-conditioned comfort, and smooth performance, making it ideal for local sightseeing, office travel, shopping trips, events, and city tours across Pune. With professional chauffeurs, flexible hourly and daily rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe and hassle-free local travel experience. Backed by 24/7 booking support, transparent pricing, and reliable service, Urbania On Rent in Pune stands out as the trusted choice for local Urbania hire in Pune.',

        top: 'Top Places to Visit in Pune with Urbania on rent in pune',


 "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort and a symbol of Maratha glory. Once the seat of Bajirao I’s administration, it features massive stone walls, grand gateways like the Delhi Darwaza, and lush lawns. Although much of it was destroyed in a fire, the remnants still echo royal grandeur. The evening light-and-sound show brings Maratha history to life. Shaniwar Wada stands as Pune’s proud emblem of heritage and valor."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a monumental landmark tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now serves as a museum showcasing Gandhi’s personal artifacts and photographs. Its sprawling gardens and Italian arches make it a peaceful retreat. It also houses the samadhis of Kasturba Gandhi and Mahadev Desai. Aga Khan Palace is Pune’s symbol of sacrifice and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. The trust behind the temple is also known for its charitable work. Devotees find immense peace and blessings here. Dagdusheth Ganpati is the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a rugged hill, Sinhagad Fort is famed for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors trek or drive up to explore its ancient ramparts, memorials, and scenic viewpoints. The fort offers breathtaking views of the Sahyadri ranges. Local vendors serve traditional pithla-bhakri meals near the summit. Sinhagad is Pune’s favorite blend of history, adventure, and nature."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from a single basalt rock, it features monolithic pillars, a circular Nandi pavilion, and a peaceful sanctum. Despite being in a busy area, it maintains a tranquil spiritual ambiance. Its ancient carvings are a testament to early Indian craftsmanship. Pataleshwar is Pune’s hidden heritage retreat."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing India’s rich cultural past. From traditional ornaments and musical instruments to household antiques and sculptures, it is a treasure trove of heritage. The recreated Mastani Mahal is a major attraction. The museum is Pune’s living archive of art and craftsmanship."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks, offering panoramic views of the city after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add to its cultural charm. Sunrise and sunset visits are especially mesmerizing. Parvati Hill is Pune’s spiritual and scenic high point."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across beautifully landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors from around the world come seeking relaxation and transformation. Osho Ashram is Pune’s international retreat for tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers. Families and photography enthusiasts enjoy peaceful walks here. The garden beautifully blends Japanese aesthetics with Indian nature. It is Pune’s serene green sanctuary."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot among locals. The vast waterscape and surrounding hills create a picturesque setting, especially during monsoon. Street vendors selling roasted corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s breezy escape for weekends and sunsets."
  }
],



"services": [
    {
      "name": "Urbania Hire for Local Trip in Pune",
      "description": "Urbania Hire for Local Trip in Pune provides reliable and comfortable Urbania vehicles for short-distance city travel. Ideal for family outings, corporate errands, and local sightseeing, the service ensures punctual pickups, spacious seating, and trained chauffeurs for a smooth travel experience."
    },
    {
      "name": "Local Urbania Rental Pune",
      "description": "Local Urbania Rental Pune offers convenient vehicle rental solutions for daily city travel and short trips within Pune. Vehicles are well-maintained, air-conditioned, and driven by professional chauffeurs, ensuring a safe, comfortable, and hassle-free local travel experience."
    },
    {
      "name": "Urbania Bus Hire for City Tour Pune",
      "description": "Urbania Bus Hire for City Tour Pune provides large buses for sightseeing, guided city tours, and group travel. With comfortable seating, air-conditioning, and experienced drivers, it guarantees a pleasant and organized journey across Pune’s popular attractions and landmarks."
    },
    {
      "name": "Urbania for Local Sightseeing Pune",
      "description": "Urbania for Local Sightseeing Pune specializes in providing vehicles for sightseeing tours, temple visits, and cultural excursions within the city. With professional chauffeurs, spacious interiors, and reliable service, passengers can enjoy a stress-free and memorable local tour."
    },
    {
      "name": "Urbania AC Local Bus Pune",
      "description": "Urbania AC Local Bus Pune offers fully air-conditioned buses for comfortable group travel within Pune. Perfect for corporate outings, family trips, and social events, the service ensures punctuality, ample seating, and smooth city navigation."
    },
    {
      "name": "Corporate Local Travel Urbania Pune",
      "description": "Corporate Local Travel Urbania Pune delivers reliable transportation for office commutes, corporate errands, and business-related local trips. Vehicles are clean, spacious, and driven by trained chauffeurs to ensure timely and professional corporate travel."
    },
    {
      "name": "Family Local Trip Urbania Pune",
      "description": "Family Local Trip Urbania Pune provides safe and comfortable vehicles for family outings, shopping trips, and leisure activities within Pune. With courteous chauffeurs, well-maintained interiors, and flexible scheduling, families can enjoy a relaxed and enjoyable local travel experience."
    },
    {
      "name": "Affordable Local Urbania Hire Pune",
      "description": "Affordable Local Urbania Hire Pune offers cost-effective solutions for local travel without compromising on comfort or service quality. Vehicles are well-maintained, equipped with air-conditioning, and driven by experienced chauffeurs, ensuring economical and reliable city transportation."
    },
    {
      "name": "Chauffeur Driven Local Urbania Pune",
      "description": "Chauffeur Driven Local Urbania Pune provides stress-free local travel with trained, background-verified drivers. Whether for family trips, office commutes, or city tours, passengers can enjoy a safe, punctual, and comfortable ride throughout Pune."
    },
    {
      "name": "Urbania for Shopping Trip Pune",
      "description": "Urbania for Shopping Trip Pune delivers convenient and spacious vehicles for shopping excursions, markets, and malls within Pune. With ample luggage space, professional chauffeurs, and comfortable seating, it ensures a hassle-free and enjoyable shopping travel experience."
    },
    {
      "name": "Urbania for Temple Visit Pune",
      "description": "Urbania for Temple Visit Pune provides reliable transport for religious trips, temple visits, and spiritual excursions within Pune. Vehicles are clean, air-conditioned, and driven by courteous chauffeurs, ensuring a safe, comfortable, and peaceful travel experience."
    },
    {
      "name": "Best Local Urbania Rental Pune",
      "description": "Best Local Urbania Rental Pune offers top-rated local transportation services known for vehicle quality, reliability, and customer satisfaction. Ideal for families, corporate clients, and tourists, it ensures a smooth, safe, and enjoyable city travel experience."
    },
    {
      "name": "Urbania Group Local Travel Pune",
      "description": "Urbania Group Local Travel Pune specializes in transporting large groups for corporate outings, social events, and family trips within Pune. With spacious vehicles, professional chauffeurs, and organized scheduling, it ensures a comfortable and hassle-free group travel experience."
    },
    {
      "name": "Urbania Hourly Rental Pune",
      "description": "Urbania Hourly Rental Pune provides flexible hourly vehicle rentals for short trips, errands, and city tours. With well-maintained vehicles, trained drivers, and reliable scheduling, passengers can enjoy convenient and efficient local travel in Pune."
    },
    {
      "name": "Trusted Local Urbania Service Pune",
      "description": "Trusted Local Urbania Service Pune delivers dependable local transportation with a focus on safety, punctuality, and comfort. With professional chauffeurs, clean and spacious vehicles, and reliable service, it ensures a seamless and stress-free travel experience for all local trips."
    }
  ],
  "tableData": [
    ["Urbania Hire for Local Trip in Pune", "Local Urbania Rental Pune"],
    ["Urbania Bus Hire for City Tour Pune", "Urbania for Local Sightseeing Pune"],
    ["Urbania AC Local Bus Pune", "Corporate Local Travel Urbania Pune"],
    ["Family Local Trip Urbania Pune", "Affordable Local Urbania Hire Pune"],
    ["Chauffeur Driven Local Urbania Pune", "Urbania for Shopping Trip Pune"],
    ["Urbania for Temple Visit Pune", "Best Local Urbania Rental Pune"],
    ["Urbania Group Local Travel Pune", "Urbania Hourly Rental Pune"],
    ["Trusted Local Urbania Service Pune", ""]
  ],





"whychoose": [
    {
        "WhyChooseheading": "Reliable Urbania Hire for Local Trip in Pune",
        "WhyChoosedescription": "Urbania Hire for Local Trip in Pune is perfect for city travel, sightseeing, family outings, and small group trips, providing comfortable and spacious transportation."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Force Urbania Vehicles",
        "WhyChoosedescription": "Urbania Hire for Local Trip in Pune offers well-maintained Force Urbania vehicles with ample seating and luggage space, ensuring smooth and hassle-free local travel."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Urbania Hire for Local Trip in Pune comes with skilled drivers familiar with Pune city routes, ensuring safe, timely, and stress-free travel within the city."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "Choose Urbania Hire for Local Trip in Pune for competitive rates with no hidden charges, making city travel budget-friendly and reliable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania Hire for Local Trip in Pune provides round-the-clock assistance for bookings, inquiries, and last-minute travel requirements within the city."
    },
    {
        "WhyChooseheading": "Flexible Local Travel Packages",
        "WhyChoosedescription": "Urbania Hire for Local Trip in Pune offers hourly rentals, half-day, and full-day bookings for local sightseeing, family outings, and city trips."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All vehicles for Urbania Hire for Local Trip in Pune are regularly cleaned, sanitized, and serviced to ensure a safe and comfortable city travel experience."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Urbania Hire for Local Trip in Pune guarantees timely pickups and dependable service, ensuring smooth and stress-free city travel."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania Hire for Local Trip in Pune available for hourly city travel?',
        answer: 'Yes, Urbania Hire for Local Trip in Pune is ideal for hourly rentals, sightseeing, family outings, and city trips within Pune.',
    },
    {
        question: 'How can I book Urbania Hire for Local Trip in Pune?',
        answer: 'You can book Urbania Hire for Local Trip in Pune via phone, WhatsApp, or online for quick and hassle-free reservations.',
    },
    {
        question: 'Why choose Urbania Hire for Local Trip in Pune for city travel?',
        answer: 'Urbania Hire for Local Trip in Pune provides spacious seating, comfortable rides, and professional drivers, making it perfect for local sightseeing and group trips.',
    },
    {
        question: 'Are the drivers experienced with Urbania Hire for Local Trip in Pune?',
        answer: 'Yes, all drivers are professionally trained, licensed, and experienced in handling Force Urbania vehicles for city and local travel.',
    },
    {
        question: 'Can I customize pickup and drop-off locations with Urbania Hire for Local Trip in Pune?',
        answer: 'Absolutely. Urbania Hire for Local Trip in Pune allows flexible pickup and drop-off locations across Pune city.',
    },
    {
        question: 'Is Urbania Hire for Local Trip in Pune available 24x7?',
        answer: 'Yes, Urbania Hire for Local Trip in Pune operates 24x7 to meet your city travel needs at any time.',
    },
    {
        question: 'Are hygiene and safety standards maintained for Urbania Hire for Local Trip in Pune?',
        answer: 'Yes, all vehicles are regularly cleaned, sanitized, and maintained with strict safety protocols for local city travel.',
    },
    {
        question: 'What payment options are available for Urbania Hire for Local Trip in Pune?',
        answer: 'Urbania Hire for Local Trip in Pune accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey to ensure a smooth and stress-free local travel experience.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rajesh Kulkarni',
        feedback: 'We hired Urbania for a local sightseeing trip in Pune. The vehicle was spacious, clean, and comfortable. Excellent service!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Priya Deshmukh',
        feedback: 'Urbania Hire for Local Trip in Pune made our city travel very easy and stress-free. Professional driver and well-maintained vehicle.',
        rating: 5,
    },
];



































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Hire for Local Trip in Pune",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-local-trip-pune.jpg",
  "description": "Urbania Hire for Local Trip in Pune offers AC and non-AC Urbania buses for city tours, local sightseeing, shopping trips, temple visits, and family or corporate local travel. Chauffeur-driven buses ensure safe, comfortable, and convenient local transportation in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-hire-for-local-trip-pune"
  }
};




    return (
        <div>
            <Helmet>
  <title>
    Call:+91 9209423113 | Urbania Hire for Local Trip in Pune | AC & Luxury Urbania Bus Rental 
  </title>

  <meta
    name="description"
    content="Book Urbania Hire for Local Trip in Pune for city tours, local sightseeing, shopping trips, temple visits, and family or corporate local travel. AC and non-AC Urbania buses with chauffeur-driven service ensure safe, comfortable, and convenient local transportation in Pune."
  />

  <meta
    name="keywords"
    content="Urbania Hire for Local Trip in Pune, Local Urbania Rental Pune, Urbania Bus Hire for City Tour Pune, Urbania for Local Sightseeing Pune, Urbania AC Local Bus Pune, Corporate Local Travel Urbania Pune, Family Local Trip Urbania Pune, Affordable Local Urbania Hire Pune, Chauffeur Driven Local Urbania Pune, Urbania for Shopping Trip Pune, Urbania for Temple Visit Pune, Best Local Urbania Rental Pune, Urbania Group Local Travel Pune, Urbania Hourly Rental Pune, Trusted Local Urbania Service Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/47.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniahireforlocaltripinpune;